import React from 'react';
import './CriticalCustom_Kratos.css'
import DashboardMain_Kratos from '../DashboardMain_Kratos/DashboardMain_Kratos';
import * as $ from 'jquery';
import { useCallback, useContext, useEffect, useState } from "react";
import { INIT_FILTER_STATE } from '../../../constants/driveglobalfilterinitalstates_kratos';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_kratos';
import useHttp from '../../../hook/use-http'
import CriticalTables_Kratos from './CriticalTables_Kratos';
import Critical_Filters_Kratos from './Critical_Filters_Kratos';
import { decodeToken } from 'react-jwt';
import CriticalTablesWithDropwon_Kratos from './CriticalTablesWithDropwon_Kratos';
import CriticalMonthGraph from './CriticalMonthGraph';
import CriticalBattery from './CriticalBattery';
import CriticalTableSection from './CriticalTableSection';

export default function Critical_vehicles_Kratos() {
  const tokenNew = JSON.parse(sessionStorage.user);
  let decodedToken = decodeToken(tokenNew.token);
  const city_name = decodedToken.city_name;
  const city_name_arr = city_name.split(",");
  const depo_name = decodedToken.depo_name;
  const depo_name_arr = depo_name.split(",");
  let sampleObj = (city_name != "") ? { ...INIT_FILTER_STATE, CITY: city_name_arr, DEPO: depo_name_arr } : INIT_FILTER_STATE

  const [gloablfilter, setGloablfilter] = useState(sampleObj)
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const log_data = () => ""

  useEffect(() => {
    fetchData({
      url: API_URL_MAIN + "auth/logging", body: {
        page_name: "Critical_Vehicles_Kratos"
      }
    }, log_data)
  }, []);

  const [fromTableToFilter_vin, setFromTableToFilter_vin] = useState(0);
  const filterSubmited = useCallback((data) => {
    if (data.VIN_NUM.length === 1) {
      setFromTableToFilter_vin(data.VIN_NUM[0])
    }
    setGloablfilter(data);
  }, []);

  const onreset = (data) => {
    setGloablfilter(data);
  }

  const arr = [
    { title: "Lowest SOH vehicles", apiEndPoint: "lowest_SOC_SOH_vehicles", packType: "A", withDropdown: "_SOH" },
    // { title: "Highest Current Imbalance", apiEndPoint: "highest_SOC_current_imbalance", packType: "total_duration", withDropdown: "_Duration" },
    { title: "Highest Temp vehicles", apiEndPoint: "highest_Temp_vehicles", packType: "A", withDropdown: "_Temp" },
    // { title: "Highest Temp vehicles (Pack B)", apiEndPoint: "highest_Temp_vehicles", packType: "B", withDropdown: "_Temp", rightZero: false },
    { title: "Lowest SOC vehicles", apiEndPoint: "lowest_SOC_SOH_vehicles", packType: "A", withDropdown: "_SOC" },
    // { title: "Highest SOC Imbalance", apiEndPoint: "highest_SOC_current_imbalance", packType: "total_soc_duration", withDropdown: "_Duration" },
    // { title: "Highest Temp vehicles (Pack C)", apiEndPoint: "highest_Temp_vehicles", packType: "C", withDropdown: "_Temp" },
    // { title: "Highest Temp vehicles (Pack D)", apiEndPoint: "highest_Temp_vehicles", packType: "D", withDropdown: "_Temp", rightZero: false },
  ]

  const [maxPackIndex, setMaxPackIndex] = useState([]);
  const resetfunc = (maxIndexA, maxIndexB, maxIndexC, maxIndexD) => {
    const maxIndices = [maxIndexA, maxIndexB, maxIndexC, maxIndexD];
    setMaxPackIndex(maxIndices)
  }

  return (
    <>
      <DashboardMain_Kratos>
        <div className="main_hole_background">
          <Critical_Filters_Kratos onsubmit={filterSubmited} gloablfilter={gloablfilter} onreset={onreset} fromTableToFilter_vin={fromTableToFilter_vin} />
          <div className="container-fluid my-2">
            <div className="row g-2">

              {/* Left */}
              <div className="col-lg-6 d-flex flex-column">

                {/* Top two tables */}
                <div className="row g-2">
                  <div className="col-12 col-md-6">
                    <CriticalTablesWithDropwon_Kratos
                      gloablfilter={gloablfilter}
                      extraThings={{
                        title: "Lowest SOH vehicles",
                        apiEndPoint: "lowest_SOC_SOH_vehicles",
                        packType: "",
                        withDropdown: "SOH",
                      }}
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <CriticalTablesWithDropwon_Kratos
                      gloablfilter={gloablfilter}
                      extraThings={{
                        title: "Lowest SOC vehicles",
                        apiEndPoint: "lowest_SOC_SOH_vehicles",
                        packType: "",
                        withDropdown: "SOC",
                      }}
                    />
                  </div>
                </div>

                {/* Bottom table */}
                <div className="flex-grow-1 mt-2 d-flex">
                  <div className="w-100">
                    <CriticalTables_Kratos
                      gloablfilter={gloablfilter}
                      extraThings={{
                        title: "Highest Temp vehicles",
                        apiEndPoint: "highest_Temp_vehicles",
                        packType: "",
                        withDropdown: "_Temp",
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Right */}
              <div className="col-lg-6 d-flex">
                <div className="card flex-fill">
                  <CriticalBattery
                    gloablfilter={gloablfilter}
                    onreset={resetfunc}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </DashboardMain_Kratos>
    </>
  )
}